export default __webpack_public_path__ + "static/media/iPhone 8 - 6.8c03f565.png";